import React from 'react'
import { RenderControl } from '@fareye/ui'
import { useMapper, IMapper, TimeZoneProvider } from '@fareye/common'
import version from '../config/npmVersions'
import ParcelDashboard from './MultiModal/ParcelGraphRender'
//NOTE: This config is used to render this Route Listing we will move this to server.

export default function ParcelGraphrendrerMapper(props: IMapper) {
  const [apiData, _] = useMapper({ ...props, version })
  return (
    <TimeZoneProvider>
      <RenderControl variant="m" state={apiData}>
        <ParcelDashboard {...props} config={apiData.data as any} />
      </RenderControl>
    </TimeZoneProvider>
  )
}
